import { render, staticRenderFns } from "./BillingsList.vue?vue&type=template&id=5adbf68a&"
import script from "./BillingsList.vue?vue&type=script&lang=js&"
export * from "./BillingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports